import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BodyCopy, Bullet, OutlinedButton } from 'secondstep-components'

const largeBreakpoint = '1140px'

export const ChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 0 32%;
  height: 100%;
  max-height: 330px;
  position: relative;

  &:not(:last-of-type) {
    border-right: 2px solid ${themeGet('colors.paleGray')};
  }

  ${themeGet('breakpoints.medium')} {
    max-width: 430px;
    width: 100%;

    &:not(:last-of-type) {
      border: none;
    }
  }
`

export const CompletedText = styled(BodyCopy)`
  line-height: 1.3125rem;

  @media (max-width: ${largeBreakpoint}) {
    display: none;
  }

  ${themeGet('breakpoints.medium')} {
    display: inline;
    margin-top: 0;
  }
`

export const CompletedTextAlt = styled(BodyCopy)`
  display: none;
  max-width: 145px;
  line-height: 1.3125rem;
  text-align: center;
  margin-top: 0.4375rem;

  @media (max-width: ${largeBreakpoint}) {
    display: block;
  }

  ${themeGet('breakpoints.medium')} {
    display: none;
  }
`

export const DonutWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 330px;
  position: relative;
`

export const PercentText = styled.span`
  font-size: 2.5rem;
  font-family: ${themeGet('font.sharpSlab.medium')};
  margin-bottom: 1.25rem;

  @media (max-width: ${largeBreakpoint}) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-bottom: 0;
  }

  ${themeGet('breakpoints.medium')} {
    position: relative;
    margin-bottom: 1.25rem;
    transform: translateY(0);
  }
`

export const StudentActivitiesCompleteWrapper = styled.div`
  display: flex;
  padding-bottom: 0.625rem;
`

export const StudentActivitiesEmptyMessageWrapper = styled(BodyCopy)`
  text-align: center;
`

export const StudentActivitiesEmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 3rem 0 4rem;

  @media screen and (max-width: 1200px) {
    padding: 3rem 0 0 1rem;
  }

  ${themeGet('breakpoints.medium')} {
    padding: 0;
  }
`

export const StudentActivitiesText = styled(BodyCopy)`
  font-family: ${themeGet('fontFamilySemibold')};
`

export const StyledBullet = styled(Bullet)`
  background-color: ${themeGet('colors.elemDigital1')};
  margin-top: 0.1875rem;
`

export const YellowBullet = styled(Bullet)`
  background-color: ${themeGet('colors.yellow')};
  margin: 0 0.5rem 0.1875rem 0;
  flex-shrink: 0;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 53%;
  transform: translateY(-50%);
  max-width: 145px;
  text-align: center;

  @media (max-width: ${largeBreakpoint}) {
    top: 50%;
  }

  ${themeGet('breakpoints.medium')} {
    top: 53%;
  }
}
`

export const UserCount = styled(BodyCopy)``

export const UserCountAfter = styled(BodyCopy)`
  font-family: ${themeGet('font.molde.regular')};
`

export const UserCountSeparator = styled.span`
  margin: 0 0.25rem;
`

export const UserCountArrow = styled.img`
  margin: 0 0 0.125rem 0.5rem;
  flex-shrink: 0;
`

export const UserCountButton = styled(OutlinedButton).attrs(
  // todo: configure theme for admin, current theme is platform
  ({ isK8Tier2 }) => ({
    isK8Tier2,
  }),
)`
  padding: 0.1875rem 1.25rem 0.125rem;
  margin-bottom: 2rem;
  border-radius: ${({ isK8Tier2 }) => (isK8Tier2 ? '1.1875rem' : '1rem')};
  border-width: 0.125rem;
  color: ${({ isK8Tier2 }) =>
    isK8Tier2 ? themeGet('colors.darkGray') : themeGet('colors.darkerGray')};
  background: ${({ isK8Tier2 }) =>
    isK8Tier2
      ? themeGet('colors.paleGray')
      : themeGet('colors.highschool.pink7')};
  border-color: ${({ isK8Tier2 }) =>
    isK8Tier2 ? themeGet('colors.blueGrayLight') : themeGet('colors.blossom')};
  display: flex;
  align-items: center;

  &:not([disabled]):hover {
    color: ${themeGet('colors.darkerGray')};
    background: ${({ isK8Tier2 }) =>
      isK8Tier2
        ? themeGet('colors.paleGray')
        : themeGet('colors.highschool.pink7')};
    border-color: ${({ isK8Tier2 }) =>
      isK8Tier2
        ? themeGet('colors.blueGrayMedium')
        : themeGet('colors.highschool.pink1')};
  }
`
